export default __webpack_public_path__ + "static/media/banner-escoladoidioma-2.44dfa1f7.jpg";